module.exports = __webpack_public_path__ + "images/emoji/lollipop.dd567421b43783da86ff.png";